import Home from './pages/Home';
import SignIn from './components/auth/SignIn';
import SignOut from './components/auth/SignOut';
// import Status from "./components/pages/Status";
import PublicationMap from './pages/PublicationMap';
// import Test from "./components/pages/Test";
import About from './pages/About';
import Notes from './pages/Notes';
import Contact from './pages/Contact';
import TimeLine from './pages/TimelineMap';
import SnaPage from './pages/SnaPage';

// HTML Header: Nav Bar
const menus = {
	menuLeft: [
		{ id: 'menu-left-01', name: 'Home', path: '/' },
		{ id: 'menu-left-02', name: 'Map', path: '/Map' },
		{ id: 'menu-left-03', name: 'Timeline', path: '/TimeLine' },
		{ id: 'menu-left-04', name: 'Citation Networks', path: '/Citation' },
		{ id: 'menu-left-06', name: 'About', path: '/About' },
		{ id: 'menu-left-07', name: 'Notes', path: '/Notes' },
		{ id: 'menu-left-08', name: 'Contact', path: '/Contact' },
	],
	menuRight: [
		{ id: 'menu-right-01', name: 'SignIn', path: '/SignIn' },
		// { id: 'menu-right-02', name: 'SignOut', path: '/SignOut' }
	],
};

// HTML Body: URL Redirect
const routes = [
	{ id: 'route-01', name: 'Home', path: '/', public: true, component: Home, withHeader: false, withFooter: false },
	{
		id: 'route-02',
		name: 'SignIn',
		path: '/SignIn',
		public: true,
		component: SignIn,
		withHeader: false,
		withFooter: false,
	},
	{
		id: 'route-03',
		name: 'SignOut',
		path: '/SignOut',
		public: true,
		component: SignOut,
		withHeader: false,
		withFooter: false,
	},
	// { id: 'route-04', name: "", path: '/Status',  public: true,   component: Status },
	{
		id: 'route-05',
		name: 'Map',
		path: '/Map',
		public: true,
		component: PublicationMap,
		withHeader: true,
		withFooter: true,
	},
	// { id: 'route-06', path: '/Test',    public: false,  component: Test }
	{
		id: 'route-07',
		name: 'About',
		path: '/About',
		public: true,
		component: About,
		withHeader: true,
		withFooter: true,
	},
	{
		id: 'route-08',
		name: 'Notes',
		path: '/Notes',
		public: true,
		component: Notes,
		withHeader: true,
		withFooter: true,
	},
	{
		id: 'route-09',
		name: 'Contact',
		path: '/Contact',
		public: true,
		component: Contact,
		withHeader: true,
		withFooter: true,
	},
	{
		id: 'route-10',
		name: 'Timeline',
		path: '/TimeLine',
		public: true,
		component: TimeLine,
		withHeader: true,
		withFooter: true,
	},
	{
		id: 'route-11',
		name: 'Citation',
		path: '/Citation',
		public: true,
		component: SnaPage,
		withHeader: true,
		withFooter: true,
	},
];

// 控制頁面是否開放: 套用 .env 設定
const pagePublicSetting = {
	TimelineMap: {
		env: 'REACT_APP_TIMELINE_PAGE',
	},
	SNA: {
		env: 'REACT_APP_SNA_PAGE',
	},
};

export { menus, routes, pagePublicSetting };
